import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { imageUrl } from "src/network/fullUrl";
import Layout from "src/components/Layout";
import NewsCard from "src/components/NewsCard";

interface NewsDetail {
  title: string;
  main_image: string;
  header: string;
  subheader: string;
  paragraphs: string[];
  other_images: string[];
}

const NewsDetails = () => {
  const { slug } = useParams<{ slug: string }>();
  const [newsDetails, setNewsDetails] = useState<NewsDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://dotmedica.com/nodes/getNewsDetails/${slug}`
        );

        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to fetch news details");
        }
        const data = await response.json();
        setNewsDetails(data);
      } catch (err: any) {
        setError(err.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetails();
  }, [slug]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!newsDetails) {
    return <div>No content available</div>;
  }

  return (
    <Layout>
      <NewsCard
        image={imageUrl(newsDetails.main_image)}
        title={newsDetails.title}
      >
        <div className="news-details">
          <h2>{newsDetails.header}</h2>
          <h3>{newsDetails.subheader}</h3>
          <div>
            {newsDetails.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
          <div>
            {newsDetails.other_images.map((image, index) => (
              <img
                key={index}
                src={imageUrl(image)}
                alt={`Other media ${index + 1}`}
                style={{ maxWidth: "100%", height: "auto", marginTop: "10px" }}
              />
            ))}
          </div>
        </div>
      </NewsCard>
    </Layout>
  );
};

export default NewsDetails;
